import { Sparkles, MessageCircle } from 'lucide-react';
import type { BuilderMode } from '../../types/guided-builder';

interface ModeTabBarProps {
  mode: BuilderMode;
  onModeChange: (mode: BuilderMode) => void;
}

export function ModeTabBar({ mode, onModeChange }: ModeTabBarProps) {
  return (
    <div className="w-full flex border-b bg-muted/30 flex-shrink-0">
      <button
        type="button"
        onClick={() => onModeChange('guided')}
        className={`flex-1 flex items-center justify-center gap-1.5 py-2.5 text-sm font-medium transition-colors ${
          mode === 'guided'
            ? 'text-foreground border-b-2 border-primary'
            : 'text-muted-foreground hover:text-foreground'
        }`}
      >
        <Sparkles className="h-4 w-4" />
        Guided
      </button>
      <button
        type="button"
        onClick={() => onModeChange('chat')}
        className={`flex-1 flex items-center justify-center gap-1.5 py-2.5 text-sm font-medium transition-colors ${
          mode === 'chat'
            ? 'text-foreground border-b-2 border-primary'
            : 'text-muted-foreground hover:text-foreground'
        }`}
      >
        <MessageCircle className="h-4 w-4" />
        Chat
      </button>
    </div>
  );
}
